import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "TransitionTriggers" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "lnr-arrow-left Arrow Left"
}
const _hoisted_5 = {
  key: 1,
  class: "lnr-arrow-right Arrow Right"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DuplicateAlertReasonModal = _resolveComponent("DuplicateAlertReasonModal")!
  const _component_TransitionTriggersModal = _resolveComponent("TransitionTriggersModal")!
  const _component_EnrolmentReviewForm = _resolveComponent("EnrolmentReviewForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.triggers.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "TransitionTitle" }, "Mark status as:", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.triggers, (trigger) => {
            return (_openBlock(), _createElementBlock("button", {
              onClick: ($event: any) => (_ctx.requestTransition(trigger)),
              key: trigger.name,
              class: "TransitionBtn NavigatorButton"
            }, [
              (trigger.isRevise)
                ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(trigger.name) + " ", 1 /* TEXT */),
              (!trigger.isRevise)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.isDuplicateAlertReasonModalShown)
            ? (_openBlock(), _createBlock(_component_DuplicateAlertReasonModal, {
                key: 0,
                isShown: _ctx.updateDuplicateAlertReasonFromChild,
                markedAsDuplicated: _ctx.isTriggerDuplicated,
                duplicateAlertReason: _ctx.duplicateAlertReason,
                onClosed: _ctx.hideDuplicateAlertReasonModal,
                onReasonUpdated: _ctx.updateDuplicateAlertReasonFromChild
              }, null, 8 /* PROPS */, ["isShown", "markedAsDuplicated", "duplicateAlertReason", "onClosed", "onReasonUpdated"]))
            : _createCommentVNode("v-if", true),
          (!_ctx.transitionTriggersStatusIsInactive)
            ? (_openBlock(), _createBlock(_component_TransitionTriggersModal, {
                key: 1,
                selectedTransitionTrigger: _ctx.selectedTransitionTrigger,
                "onUpdate:selectedTransitionTrigger": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTransitionTrigger) = $event)),
                triggerPayload: _ctx.triggerPayload,
                "onUpdate:triggerPayload": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.triggerPayload) = $event)),
                onResetTrigger: _ctx.resetTrigger
              }, null, 8 /* PROPS */, ["selectedTransitionTrigger", "triggerPayload", "onResetTrigger"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_EnrolmentReviewForm)
        ]))
      : (_ctx.selectionHasSameStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
            _createStaticVNode("<p class=\"TransitionTitle\">Mark status as:</p><div class=\"NotAvailableWarning\"><i class=\"lnr-clipboard-alert WarningIcon\"></i><p class=\"WarningText\">No next steps available for the selected enrolments.</p><p class=\"WarningText\">Please revise your selection and try again.</p></div>", 2)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
            _createStaticVNode("<p class=\"TransitionTitle\">Mark status as:</p><div class=\"NotAvailableWarning\"><i class=\"lnr-clipboard-alert WarningIcon\"></i><p class=\"WarningText\">Selected enrolments have no overlapping next steps that they can be transitioned to.</p><p class=\"WarningText\">Please revise your selection and try again.</p></div>", 2)
          ]))]))
  ]))
}